
import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
// import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';



export default class CustomFunctions {
  /**
   * 初期化
   * @param options
   */
  constructor(options) {
    this.options = $.extend(options);
    this.init();
  }

  /**
   * 実行する
   */
  init() {
    this.infiniteSlider();
    this.initSlider();
    this.initMainSlider();
    this.hoverOnSubmenu();
    this.initGallery();
    this.mycode();
    // this.handleFormCategory();
    this.scrollHint();
    this.infiniteTextSlider();
  }


  /**
   * カスタム関数
   */

  scrollHint() {
    new ScrollHint('.js-scrollable', {
      i18n: {
        scrollable: 'スクロールできます'
      }
    });
  }

  handleFormCategory() {
    const selects = document.querySelectorAll('select[data-target]');
    if (!selects.length) return;

    $("#js-category-select").on('change', function () {
      const category = $(this).find(':selected').data('category');

      for (let i = 0; i < selects.length; i++) {
        if($(selects[i]).data("target") !== category) {
          $(selects[i]).prop('disabled', 'disabled');
        } else {
          $(selects[i]).prop('disabled', false);
        }
      }
    });
  }

  initGallery() {
    if ($("#gallery-carousel").length === 0) return;

    const options = {
      pagination: false,
      gap: 36,
      classes: {
        arrows: 'splide__arrows your-class-arrows',
        arrow: 'splide__arrow your-class-arrow',
        prev: 'splide__arrow--prev your-class-prev',
        next: 'splide__arrow--next your-class-next',
      },
      // reducedMotion: {
      //   autoplay: true,
      //   speed: 1000,
      // },
    }

    var gallery = new Splide('#gallery-carousel', options);

    var thumbnails = document.getElementsByClassName('thumbnail');
    var current;

    for (var i = 0; i < thumbnails.length; i++) {
      initThumbnail(thumbnails[i], i);
    }

    function initThumbnail(thumbnail, index) {
      thumbnail.addEventListener('click', function () {
        gallery.go(index);
      });
    }

    gallery.on('mounted move', function () {
      var thumbnail = thumbnails[gallery.index];

      if (thumbnail) {
        if (current) {
          current.classList.remove('is-active');
        }

        thumbnail.classList.add('is-active');
        current = thumbnail;
      }
    });

    gallery.mount();
  }

  hoverOnSubmenu() {
    $(".l-header").find(".is-parent").hover(function () {

      $(this).toggleClass("is-hovered");
    });

  }

  initSlider() {
    const options = {
      type: 'loop',
      focus: 'center',
      autoWidth: true,
      gap: 40,
      pagination: false,
      rewind: false,
      cloneStatus: false,
      classes: {
        arrows: 'splide__arrows your-class-arrows',
        arrow: 'splide__arrow your-class-arrow',
        prev: 'splide__arrow--prev your-class-prev',
        next: 'splide__arrow--next your-class-next',
      },
      reducedMotion: {
        autoplay: true,
        speed: 1000,
      },
      breakpoints: {
        1000: {},
      }
    };

    var slider = $(".splide.js-case-splide");

    if (!slider.length) return;

    if (slider.find(".splide__slide").length < 2 && window.innerWidth > 750) {
      slider.removeClass("splide");
      slider.find(".splide__slide").removeClass("splide__slide");
      return;
    }

    if (slider.find(".splide__slide").length === 1 && window.innerWidth < 750) {
      slider.removeClass("splide");
      slider.find(".splide__slide").removeClass("splide__slide");
      return;
    }

    // else if (slider.find(".splide__slide").length === 2 || window.innerWidth < 750) {
    //   options.clones = 3;
    // }

    new Splide('.splide.js-case-splide', options).mount();

  }

  initMainSlider() {

    var mainSlides = $(".js-mv-slides");

    if (mainSlides.length === 0) return;


    for (let i = 0; i < mainSlides.length; i++) {

      if ($(mainSlides[i]).hasClass("is-slide-3") && window.innerWidth > 750) {
        $(mainSlides[i]).append($(mainSlides[i]).find(".c-main-visual__slide").clone());
        $(mainSlides[i]).append($(mainSlides[i]).find(".c-main-visual__slide").clone());
        $(mainSlides[i]).append($(mainSlides[i]).find(".c-main-visual__slide").clone());
      } else {
        $(mainSlides[i]).append($(mainSlides[i]).find(".c-main-visual__slide").clone());
        $(mainSlides[i]).append($(mainSlides[i]).find(".c-main-visual__slide").clone());
      }
    }

    setTimeout(function () {
      mainSlides.addClass("is-active");
    }, 100)
  }

  // ループスライダー
  infiniteSlider() {
    let splideInfinites = document.querySelectorAll(".js-infinite-slider");
    if (splideInfinites) {

      splideInfinites = Array.prototype.slice.call(splideInfinites, 0);

      for (var i = 0; i < splideInfinites.length; i++) {
        let splideinfinite = new Splide(splideInfinites[i], {
          autoWidth: true,
          gap: 16,
          type: 'loop',
          drag: false,
          arrows: false,
          pagination: false,

          autoScroll: {
            speed: 0.5,
            pauseOnHover: false,
            pauseOnFocus: false,
          },
        })
        splideinfinite.mount(window.splide.Extensions);
      }
    }
  }


  infiniteTextSlider() {
    let splideInfinites = document.querySelectorAll(".js-text-scroll");
    if (splideInfinites) {

      splideInfinites = Array.prototype.slice.call(splideInfinites, 0);

      for (var i = 0; i < splideInfinites.length; i++) {
        let splideinfinite = new Splide(splideInfinites[i], {
          autoWidth: true,
          gap: 120,
          type: 'loop',
          drag: false,
          arrows: false,
          pagination: false,
          autoScroll: {
            speed: 1.5,
            pauseOnHover: false,
            pauseOnFocus: false,
          },
          breakpoints: {
            750: {
              gap: 60,
              autoScroll: {
                speed: 1,
              },
            },
          }
        })
        splideinfinite.mount(window.splide.Extensions);
      }

      // splideInfinites.forEach((item) => {
      //
      // })
    }
  }


  // 複製して作業
  mycode() {
    let boxes = document.querySelectorAll(".js-scroll-reveal");
    boxes = Array.prototype.slice.call(boxes, 0);

    const options = {
      root: null, // 今回はビューポートをルート要素とする
      rootMargin: "-40% 0px", // ビューポートの中心を判定基準にする
      threshold: 0 // 閾値は0
    };
    const observer = new IntersectionObserver(doWhenIntersect, options);
// それぞれのboxを監視する
    boxes.forEach(box => {
      observer.observe(box);
    });

    /**
     * 交差したときに呼び出す関数
     * @param entries
     */
    function doWhenIntersect(entries) {
      // 交差検知をしたもののなかで、isIntersectingがtrueのDOMを色を変える関数に渡す
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          activateIndex(entry.target);
        }
      });
    }

    /**
     * 目次の色を変える関数
     * @param element
     */
    function activateIndex(element) {
      $(element).find(".js-reveal-image").addClass("is-animate");
    }
  }


}




